import { activeScopeKey } from '@features/account-view/active';
import type { CatalogListParams } from './list-params';

export const catalogKeys = {
  all: ['catalog'] as const,
  /**
   * Which list shape the API last answered with ('legacy' | 'v2') at the active
   * level; kept until logout clears the cache. Per level: the account level
   * reads V2 once orders_account_view is on while each division may stay
   * legacy (EN-4396, D138 b).
   */
  source: (level = activeScopeKey().level) =>
    [...catalogKeys.all, 'source', level] as const,
  lists: () => [...catalogKeys.all, 'list'] as const,
  list: (params: CatalogListParams) =>
    [...catalogKeys.lists(), params, activeScopeKey()] as const,
  pageDatas: () => [...catalogKeys.all, 'page-data'] as const,
  pageData: (params: CatalogListParams) =>
    [...catalogKeys.pageDatas(), params, activeScopeKey()] as const,
  variationsOf: (parentId: string) =>
    [...catalogKeys.all, 'variations', parentId] as const,
  variations: (parentId: string, search: string) =>
    [...catalogKeys.variationsOf(parentId), search] as const,
  /* EN-4396: the V2 shape of a parent's variants; apart from `variationsOf` so the two shapes never share an entry. */
  v2Variations: (parentId: string) =>
    [...catalogKeys.all, 'v2-variations', parentId] as const,
  /* M2: the marketplace facet of a level and division filter, for the list's query (view, search, type, ...). */
  markets: (scope: ReturnType<typeof activeScopeKey>, params: object = {}) =>
    [...catalogKeys.all, 'markets', scope, params] as const,
  conflictsCount: (regionId: unknown) =>
    [...catalogKeys.all, 'conflicts-count', regionId] as const,
  feeds: (params: unknown) => [...catalogKeys.all, 'feeds', params] as const,
  scmReports: (params: unknown) =>
    [...catalogKeys.all, 'scm-reports', params] as const,
};
